import EventActionProto from '../event-action-proto';

module.exports = class EventCustomViewDelete extends EventActionProto {

    constructor(uid, data, fromSID, companyId) {
        super(uid, data, companyId);
    }

    validate() { return true; }

    process() {

        // reset menu
        gd.session.customViews.remove(this.data.id);

        super.process();
    }
};